import { FormattedMessage } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';
import { glossary } from '@sorare/core/src/lib/glossary';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import banner from 'components/landing/EarlyAccess/assets/banner/banner.png';

const Wrapper = styled.section`
  display: flex;
  width: 100%;
  max-width: 1440px;
  aspect-ratio: 1440 / 810;
  margin: auto;
  padding: var(--double-unit);
  background-image: url(${banner});
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
  @media ${laptopAndAbove} {
    padding: 10% var(--quadruple-unit) var(--quadruple-unit)
      var(--quadruple-unit);
  }
`;

const Content = styled(Vertical)`
  max-width: 540px;
  margin-top: auto;
  @media ${laptopAndAbove} {
    margin: 0 0 auto auto;
  }
`;

const Title = styled.h1`
  font-size: var(--fs-landing-title-l);
  font-family: var(--rigid-square);
  text-transform: uppercase;
  line-height: 1;
`;

const Subtitle = styled.h2`
  font-size: var(--t-headline-m);
  @media ${laptopAndAbove} {
    font: var(--t-display-s);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const NBABanner = () => {
  const { signUp } = useConnectionContext();
  return (
    <Wrapper
      style={
        {
          '--background': `image-set(url(${banner}) type('image/avif'), url(${banner}) type('image/png'))`,
        } as CSSProperties
      }
    >
      <Content gap={0}>
        <Title>
          <FormattedMessage
            id="landing.EarlyAccess.NBABanner.title"
            defaultMessage="NBA is back"
          />
        </Title>
        <Vertical gap={3}>
          <Subtitle>
            <FormattedMessage
              id="landing.EarlyAccess.NBABanner.description"
              defaultMessage="This season, let your cards do the talking"
            />
          </Subtitle>
          <ButtonContainer>
            <Button
              size="medium"
              color="secondary"
              onClick={() => signUp(undefined, Sport.NBA)}
            >
              <FormattedMessage {...glossary.startCollecting} />
            </Button>
            <Button
              size="medium"
              color="tertiary"
              href="https://sorare.com/blog/sorare-nba-2024-25-more-ways-to-play-more-ways-to-win"
            >
              <FormattedMessage {...glossary.learnMore} />
            </Button>
          </ButtonContainer>
        </Vertical>
      </Content>
    </Wrapper>
  );
};
